<template>
  <div>
    <commBanner :obj="obj"></commBanner>
    <titleHead :headTitle="headTitle"></titleHead>
    <div class="w80 mb-30">
      <el-container>
        <el-aside width="330px">
          <sidebar></sidebar>
        </el-aside>
        <el-main>
          <companySide
            v-if="type"
            :isButton="isButton"
            @release="gorelease()"
          ></companySide>
          <headSide v-else @release="gorelease()"></headSide>

          <!--表单-->
          <div  class="mt-30">
            <contTitle :obj="obj" :contTitle="contTitle"  @onBacker="Backer()"></contTitle>
            <el-form
              class="info_form"
              ref="form"
              :model="form"
              label-width="100px"
              :rules="rules"
              :label-position="labelPosition"
            >
              <div class="fct mt-30">
                <div style="width: 50%" class="box_textarea">
                  <el-form-item
                    label="资料标题 :"
                    prop="title"
                    style="width: 90%"
                  >
                    <el-input
                      type="textarea"
                      :maxlength="50"
                      placeholder="不超过50字"
                      v-model="form.title"
                      clearable
                    ></el-input>
                  </el-form-item>
                </div>
                <div style="width: 50%">
                  <el-form-item label="资料类别 :" prop="category">
                    <!-- <el-cascader
										 :options="categoryList" 
										 :props="optionProps"
										 v-model="form.category"
										 :show-all-levels="false"
										 clearable
										 style="width:100%;"
											@change="onChang()">
										</el-cascader> -->
                    <el-select
                      v-model="form.category"
                      placeholder="请选择资料类别"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in categoryList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.id"
                        clearable
                        style="width: 100%"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    label="资料价值 :"
                    prop="fileprice"
                    style="width: 100%"
                  >
                    <el-input
                      v-model="form.fileprice"
                      type="number"
                      :disabled="priceAdd"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    class="file"
                    prop="fileresources"
                    label="资料文件 :"
                    style="width: 100%"
                  >
                    <el-input v-model="form.fileresources" clearable></el-input>
                    <el-upload
                      class="upload-demo"
                      action="/api/zwb/app/oss/private/upload"
                      :headers="{ token: token }"
                      :on-success="onSuccess"
                      :show-file-list="false"
                      :before-upload="handlePictureCardPreview"
                      list-type="picture"
                    >
                      <button class="busin_btn" size="small" @click.prevent="">
                        点击上传
                      </button>
                    </el-upload>
                  </el-form-item>
                </div>
              </div>
              <p class="bater_tetx">只能上传jpg/png文件 280*145px，1M以内</p>
              <el-form-item
                class="file"
                label="资料封面 :"
                prop="covers"
                style="width: 100%"
              >
                <el-input v-model="form.covers" clearable></el-input>
                <el-upload
                  class="upload-demo"
                  :headers="{ token: token }"
                  action="/api/zwb/app/oss/public/upload"
                  :on-success="successFill"
                  :show-file-list="false"
                  :limit="1"
                  :before-upload="handleCover"
                >
                  <el-button class="busin_btn">点击上传</el-button>
                </el-upload>
              </el-form-item>
              <el-form-item
                class="mt-40"
                label="资料作者 :"
                prop="fileauthor"
                style="width: 100%"
              >
                <el-input v-model="form.fileauthor" clearable></el-input>
              </el-form-item>
              <el-form-item
                    label="价值积分 :"
                    prop="integral"
                    style="width: 100%"
                  >
                    <el-input
                      v-model="form.integral"
                      :disabled="priceAdd"
                      type="number"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                    ></el-input>
                  </el-form-item>
              <!-- <el-form-item
                label="资料格式 :"
                prop="fileformat"
                style="width: 100%"
              >
                <el-select
                  v-model="form.fileformat"
                  placeholder="请选择文档格式"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item
                label="发布时间 :"
                prop="createtime"
                style="width: 100%"
              >
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  :picker-options="pickerOptionsStart"
                  v-model="form.createtime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  @change="startTimeStatus"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
              <div class="tel">
                <el-form-item label="资料详情:">
                   <tinymceEditor
                    class="mt-20"
                    v-model="form.content"
                    ref="editor"
                  ></tinymceEditor>
                </el-form-item>
                <el-form-item   prop="agree" class="fuck">
                  <el-checkbox v-model="form.agree" name="checked"></el-checkbox>
                  <div style="margin-left: 5px">
                    我已阅读并同意《
                    <span class="agree" @click="settChange()">供需信息发布声明</span>
                    》
                  </div>
                </el-form-item>

                <!-- <p class="text_center"></p> -->
               
              </div>
              <div class="tel mt-20">
                <el-button class="refer" @click="submitForm('form')">{{
                  buttonText
                }}</el-button>
              </div>
            </el-form>
          </div>

          <!--发布声明弹框-->
          <div class="sett_dialog" v-show="dialogTableVisible">
              <div class="sett_cox"></div>
              <div class="sett_dialog_box">
                <div class="sett_matter">
                  <p class="sett_title">供需信息发布声明</p>
                  <p class="sett_jitr">
                    <span v-if="!isImg">{{ time }}s</span>
                    <img
                      v-show="isImg"
                      src="../../assets/images/sign.png"
                      @click.prevent="onText()"
                    />
                  </p>
                </div>
                <div class="sett_desc" v-html="issueStatement.des"></div>
              </div>
          </div>

        </el-main>
      </el-container>
    </div>
  </div>
</template>
<script>
import {
  addMeans,
  meansList,
  getDetail,
  editMeas,
  delMeas,
  myBrowseList,
} from "@/api/coment";
import { getToken } from "@/utils/auth";
import {agreement,getcrtinfolist} from '@/api/coment'
import sidebar from "../../common/sidebar";
import companySide from "../../common/companySide";
import headSide from "../../common/headSide";
import commBanner from "../../common/commBanner";
import titleHead from "../../common/titleHead";
import contTitle from "../../common/contTitle";
import tinymceEditor from "../../common/tinymceEditor.vue";
export default {
  components: {
    sidebar,
    headSide,
    companySide,
    commBanner,
    titleHead,
    contTitle,
    tinymceEditor
  },
  data() {
    return {
      contTitle: "添加资料",
      buttonText: "发布资料",
      headTitle:'我的资料',
      obj: {
        title: "我的资料",
        isShow: false,
        backer: false,
        roleType: "",
        personalType: 9
      },
      obj1: {
        title: "我的资料",
        isShow: false,
        roleType: "",
        personalType: 9,
      },
      paletteObj: {
        paletteTitle: "我发布的资料",
        paletteCount: "",
        isShow: true,
        paletteName: "发布资料",
      },
      form: {
        userid: "",
        title: "",
        category: "",
        fileprice: "0",
        fileresources: "",
        content: "",
        covers: "", //封面
        createtime: "",
        fileauthor: "", //发布作者
        integral: "0", //价值积分
        fileformat: ".pdf", //文档格式
        agree:''
      },
      rules: {
        title: [{ required: true, message: "请输入资料标题", trigger: "blur" }],
        category: [
          { required: true, message: "请选择资料类别", trigger: "change" },
        ],
        fileprice: [
          { required: true, message: "请输入资料价值", trigger: "blur" },
        ],
        fileresources: [
          { required: true, message: "请选择资料文件", trigger: "change" },
        ],
        covers: [
          { required: true, message: "请选择资料封面", trigger: "change" },
        ],
        createtime: [
          { required: true, message: "请选择发布时间", trigger: "change" },
        ],
        fileauthor: [
          { required: true, message: "请输入资料作者", trigger: "blur" },
        ],
        integral: [
          { required: true, message: "请输入积分价值", trigger: "blur" },
        ],
        fileformat: [
          { required: true, message: "请输入资料格式", trigger: "change" },
        ],
        agree: [{ required: true, message: "请接受智污邦发布声明",trigger: "change"}]
      },
      labelPosition: "left",
      fileList: [],
      categoryList: [], //行业分类
      token: getToken(),
      notCode: false,
      nextTour: false,
      nubmerList: [], //浏览用户
      type: false,
      isButton: false,
      dialogTableVisible: false,
      isImg: false,
      time: 10,
      issueStatement: "",
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.form.createtime) {
            return time.getTime() <= Date.now();
          }
        },
      },
      options: [
        { value: ".txt（纯文字文档）", label: ".txt（纯文字文档）" },
        { value: ".rtf（丰富文本格式）", label: ".rtf（丰富文本格式）" },
        { value: ".doc（微软Word文档）", label: ".doc（微软Word文档）" },
        { value: ".xls（微软Excel表格）", label: ".xls（微软Excel表格）" },
        { value: ".wpd", label: ".wpd" },
        { value: ".pdf", label: ".pdf" },
      ],
      priceAdd: false
    };
  },
  created() {
    this.getAgreement();
    this.getCtrolnameinfo();  // 是否允许用户设置资料价格
    let type = this.$store.state.user.userInfo.type;
    let id = this.$route.query.id;
    if(id){
       this.obj.backer = true;
       this.getInfo(id)
    }
    this.obj.roleType = type;
    if(type == 3){
      this.type = true;
      this.headTitle = "企业资料";
      this.obj.title = "企业资料";
    }
  },
  computed:{
    Industry(){
       return this.$store.getters.industry;
    }
  },
  watch:{
    Industry:{
      handler(val){
        if(val[0] != undefined){
          this.categoryList = val[0].children;
        }
        if(val[8] != undefined){
          for(var i in val[8].children){
            this.categoryList.push(val[8].children[i])
          }
        }
      },
      immediate:true
    }
  },
  methods: {
    //发布
    gorelease() {
      this.$router.push("/demand");
    },
    //返回列表
    Backer(){
      this.$router.push('/means')
    },
    //查看详情
    getInfo(id) {
      this.buttonText = '提交资料'
      let params = { id:id };
      getDetail(params)
        .then((res) => {
          if (res.code == 0) {
            this.form = res.data;
          }
        })
        .catch((err) => {});
    },
    startTimeStatus(value) {
      this.form.createtime = value;
    },
    //文件上传前回调
    handlePictureCardPreview(file) {
      const isLtM = file.size / 1024 / 1024 < 30;
      if (!isLtM) {
        this.$message.error("上传文件大小不能超过 30MB!");
      }
      return isLtM;
    },
    //上传封面
    handleCover(file) {
      const isLtM = file.size / 1024 / 1024 < 1;
      const extension =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      if (!extension) {
        this.$message.error("上传资料封面只能是 JPG,PNG 格式!");
      }
      if (!isLtM) {
        this.$message.error("上传资料封面不能超过1MB!");
        return isLtM;
      }
      // }else{
      //    const isSize = new Promise((resolve, reject) => {
      //           const width = 280;
      //           const height = 145;
      //           const _URL = window.URL || window.webkitURL;
      //           const img = new Image();
      //           img.onload = () => {
      //               const valid = img.width >= width && img.height >= height && img.width === img.height;
      //               valid ? resolve() : reject();
      //           };
      //           img.src = _URL.createObjectURL(file);
      //       }).then(
      //           () => {
      //               return file;
      //           },
      //           () => {
      //               this.$message.error('图片尺寸限制最小为280 x 145，大小不可超过1MB');
      //               return Promise.reject();
      //           },
      //       );
      //       return isSize;

      // }
    },
    //文件上传成功
    onSuccess(res) {
      if (res.code == 0) {
        this.$message({
          message: "上传成功！",
          type: "success",
        });
        this.$set(this.form,"fileresources",res.url);
      }
    },
    successFill(res) {
      if (res.code == 0) {
        this.$message({
          message: "上传成功！",
          type: "success",
        });
        this.$set(this.form,"covers",res.url);
      }
    },
    //发布资料
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.id !== undefined) {
            editMeas(this.form)
              .then((res) => {
                if (res.code == 0) {
                  this.$message({
                    message: "编辑成功！",
                    type: "success",
                    duration: 1000,
                    onClose: () => {
                      this.$router.push('/means')
                    },
                  });
                }
              }).catch((err) => {});
          } else {
            this.form.userid = this.$store.state.user.userInfo.data.userId;
            addMeans(this.form)
              .then((res) => {
                if (res.code == 0) {
                  this.$message({
                    message: "发布成功！审核通过后获得积分",
                    type: "success",
                    duration: 1000,
                    onClose: () => {
                      this.$router.push('/means')
                    },
                  });
                }
              }).catch((err) => {});
          }
        }
      });
    },
    //查询发布声明
    getAgreement() {
      agreement()
        .then((res) => {
          this.issueStatement = res.page.filter((item) => item.name == "供需信息发布声明")[0];
        }).catch((err) => {});
    },
    settChange() {
      this.dialogTableVisible = true;
      this.timer = setInterval(() => {
        this.time--;
        if (this.time == 0) {
          clearInterval(this.timer);
          this.isImg = true;
        }
      }, 1000);
    },
    onText() {
      this.dialogTableVisible = false;
    },
    //选中
    onChang(val) {
      //this.form.category = this.form.category[this.form.category.length-1];
    },

    // 是否允许用户设置价格
    getCtrolnameinfo(){
      let param = {name: "priceAdd"}
      getcrtinfolist(param).then((res) => {
        console.log(res)
        console.log(res.data.length)
        if(res.data.length == 0){
          this.priceAdd = true
        }else{
          this.priceAdd = false
        }
      })
    }
  },
};
</script>
<style scoped>
.dn {
  display: none;
}
.mt-40 {
  margin-top: 40px;
}
.ml-12 {
  margin-left: 12px;
}
.ml-15 {
  margin-left: 15px;
}
.ml-20 {
  margin-left: 20px;
}
.mt-20 {
  margin-top: 20px;
}
.tel {
  text-align: left;
}
.red {
  color: #ff7171;
}

.el-form-item {
  text-align: left;
}
.info_form >>> .el-input__inner {
  height: 50px;
}
.info_form >>> .el-select .el-input__inner {
  height: 50px;
}

.box_textarea >>> .el-textarea__inner {
  /* width: 300px; */
  height: 168px;
}

/deep/.file {
  position: relative;
}
/deep/ .upload-demo {
  position: absolute;
  top: 0;
  right: 0;
}
.busin_btn {
  width: 103px;
  height: 50px;
  background: #e5e5e5;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  border: none;
}
.info_form >>>.el-button--default:hover{
  background: #e5e5e5 ;
  color: #999999;
}

.info_form >>> .refer {
  width: 114px;
  height: 40px;
  background: #3bbb35;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  margin-top: 30px;
}
.info_form >>> .refer:hover{
   border-color: #3bbb35;
} 
.text_center {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.el-pagination {
  margin-top: 40px;
}
.bater_tetx {
  text-align:left;
  height: 30px;
  margin-bottom: 15px;
  font-size: 12px;
  color: #999999;
}


/**发布弹框样式 */
.sett_dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  margin: 0;
  z-index: 999;
}
.sett_dialog_box {
  width: 500px;
  height: 600px;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 3px;
  transform: translate(-50%, -50%);
  background: #ffffff;
  overflow: auto;
}
.sett_cox {
  position: fixed;
  left: 0;
  /* opacity: 0.3; */
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(0, 0, 0, 0.8);
  /* z-index:2003 !important; */
}
.sett_matter {
  position: relative;
  height: 50px;
}
.sett_title {
  font-size: 22px;
  color: #666666;
  height: 30px;
  line-height: 48px;
  text-align: center;
}
.sett_jitr {
  position: absolute;
  right: 20px;
  top: 10px;
}
.sett_jitr img {
  width: 20px;
  height: 20px;
}
/**协议弹框 */
.sett_dialog >>> .el-dialog {
  width: 500px;
  height: 600px;
}
.sett_dialog >>> .el-dialog__header {
  text-align: center;
}
.sett_dialog >>> .el-dialog__title {
  font-size: 24px;
}
.sett_desc {
  padding: 30px;
  font-size: 14px;
  line-height: 24px;
  color: #666666;
}
/deep/ .fuck .el-form-item__content {
  display: flex;
  align-items: center;
}
.agree {
  cursor: pointer;
  color: #69cc1e;
}
.agree:hover {
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/view/coment/meansAdd.vue